import type { SelectOption } from '@/components/ui/select';
import { cn } from '@/lib/utils';

type DetailsFieldProps = {
  label: string;
  value?: string | number | null;
  className?: string;
  options?: SelectOption[];
};

export const OptionsDetailsField = ({
  label,
  value = '',
  options = [],
  className,
}: DetailsFieldProps) => {
  const labeledValue = options.find(({ id }) => id === value)?.title;
  return (
    <div className={cn('grid grid-cols-2 gap-2', className)}>
      <p className="min-w-[20%] grow-0 text-base text-text-secondary">{label}:</p>
      <p className="w-4/5 self-end whitespace-nowrap break-words text-left text-base">
        {labeledValue ? labeledValue : '-'}
      </p>
    </div>
  );
};
